import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=77479fae&scoped=true"
import script from "./SelectType.vue?vue&type=script&lang=js"
export * from "./SelectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77479fae",
  null
  
)

export default component.exports